import { render, staticRenderFns } from "./PfLoanEarlySettlementDetails.vue?vue&type=template&id=2b15f7a4"
import script from "./PfLoanEarlySettlementDetails.vue?vue&type=script&lang=js"
export * from "./PfLoanEarlySettlementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports